<template>
    <el-card shadow="never" class="aui-card--fill">
      <div class="mod-demo__scopecity">
       
        
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.userName" placeholder="经纪人姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.mobilePhone" placeholder="经纪人手机号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.superiorName" placeholder="上级经纪人" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.superiorPhoneNumber" placeholder="上级经纪人手机号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.superiorSuperiorName" placeholder="上上级经纪人" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.superiorSuperiorPhoneNumber" placeholder="上上级经纪人手机号" clearable></el-input>
        </el-form-item>
         
          <el-form-item>
            <el-button @click="getDataList()">{{ $t('query') }}</el-button>
          </el-form-item>
  <!--        <el-form-item>-->
  <!--          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>-->
  <!--        </el-form-item>-->
          <!-- <el-form-item>
            <el-button v-if="$hasPermission('sys:scopecity:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
          </el-form-item> -->
     
        </el-form>
        
        <el-table  v-loading="dataListLoading" :data="dataList" border style="width: 100%;">
        
          <el-table-column prop="userName" label="经纪人" header-align="center" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="childHandle(scope.row)">{{ scope.row.userName }}</el-button>
            </template>
          </el-table-column>
          <el-table-column  width="200px" prop="mobilePhone" label="手机号" header-align="center" align="center"></el-table-column>
          <el-table-column prop="userType" label="类型" header-align="center" align="center">
            <template slot-scope="scope">
              {{ geteducation(scope.row.userType,'userType')}}
            </template>
          </el-table-column>
          <el-table-column prop="partnerOrganization" label="合作机构" header-align="center" align="center"></el-table-column>
          <el-table-column prop="vipLevelId" label="等级" header-align="center" align="center">
            <template slot-scope="scope">
              {{ geteducation(scope.row.vipLevelId,'vipLevelId')}}
            </template>
          </el-table-column>
          <el-table-column prop="levelUpMethod" label="升级方式" header-align="center" align="center"></el-table-column>
          <el-table-column prop="teamSize" label="团队规模" header-align="center" align="center"></el-table-column>
          <el-table-column prop="superiorName" label="上级" header-align="center" align="center"></el-table-column>
          <el-table-column prop="superiorPhoneNumber" label="上级手机号" header-align="center" align="center"></el-table-column>
          <el-table-column prop="superiorSuperiorName" label="上上级" header-align="center" align="center"></el-table-column>
          <el-table-column prop="superiorSuperiorPhoneNumber" label="上上级手机号" header-align="center" align="center"></el-table-column>
          <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
          <el-table-column prop="levelUpTime" label="升级时间" header-align="center" align="center"></el-table-column>
          <el-table-column prop="cumulativeEntry" label="累计进件" header-align="center" align="center"></el-table-column>
          <el-table-column prop="cumulativeLoan" label="累计放款" header-align="center" align="center"></el-table-column>
          <el-table-column prop="accruedAllowance" label="累计津贴" header-align="center" align="center"></el-table-column>
          <el-table-column prop="cumulativeCommission" label="累计提成" header-align="center" align="center"></el-table-column>
          <el-table-column prop="cumulativeRewards" label="累计活动奖励" header-align="center" align="center"></el-table-column>
          <!-- <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-button v-if="$hasPermission('sys:scopecity:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
              <el-button v-if="$hasPermission('sys:scopecity:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
        </el-pagination>
      </div>
        <!-- 弹窗, 新增 / 修改 -->
        <!-- <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update> -->
    </el-card>
  </template>
  
  <script>
  import mixinViewModule from '@/mixins/view-module'
//   import AddOrUpdate from './scopecity-add-or-update'
  import { addDynamicRoute } from '@/router'
  export default {
    mixins: [mixinViewModule],
    data () {
      return {
        mixinViewModuleOptions: {
          getDataListURL: '/sys/sluser/page',
          getDataListIsPage: true,
          exportURL: '/sys/sluser/export',
          deleteURL: '/sys/sluser',
          deleteIsBatch: true
        },
        filterText:'',
        defaultProps: {
            children: 'children',
            label: 'label',
          },
        vipLevels: [],
        userTypes: [],
        dataForm: {
          userName: '',
          mobilePhone: '',
          superiorName: '',
          superiorPhoneNumber: '',
          superiorSuperiorName: '',
          superiorSuperiorPhoneNumber: '',
        }
      }
    },
    components: {
    //   AddOrUpdate
    
    },
    created () {
      if (this.mixinViewModuleOptions.createdIsNeed) {
        this.query()
        this.getvipLevelOptions()
        this.getuserTypeOptions()
      }
    },
    computed:{
      getPageList(){
        return this.dataList.map(item => {
          return {
            label: item.pageName,
            ...item,
            children: [
            ...item.city.split(',').map(item1 => ({ label: item1, city: item.city, pageName: item.pageName, id: item.id})),
           ]
          }
        })
      }
    },
    
    watch: {
        filterText(val) {
          this.$refs.tree.filter(val);
        }
      },
    methods: {
      filterNode(value, data) {
        console.log(value,data)
          if (!value) return true;
          return data.label.indexOf(value) !== -1;
        },
      
      // 回调函数 返回树形数据
      getArr(event){
        return [{
            label: event.pageName,
            children: [
              ...event.city.split(',').map(item => ({ label: item }))
           ]
          }]
      },
      handleNodeClick(data) {
          console.log(data);
          this.childHandle(data)
       },
    geteducation(v,name){
      if(name == 'userType')  return this.userTypes.filter(item => item.value == v)[0]?.label ;
      return this.vipLevels.filter(item => item.value == v)[0]?.label ;
    
      // if(name == 'education') return this.educations.filter(item => item.value == v)[0]?.label ;
      // if(name == 'vipLevelId') return this.vipLevels.filter(item => item.value == v)[0]?.label ;
      // if(name == 'maritalStatus') return this.maritalStatus.filter(item => item.value == v)[0]?.label ;
      // if(name == 'isAuth') return this.isAuth.filter(item => item.value == v)[0]?.label ;
      // if(name == 'shareProfit') return this.shareProfit.filter(item => item.value == v)[0]?.label ;
    },
      //初始用户类型名称下拉框中的选项
    async getuserTypeOptions() {
             this.$http.get(`/sys/dict/data/list?dataType=userType`).then(({ data: res }) => {
                if (res.code !== 0) {
                    return this.$message.error(res.msg)
                }
                this.userTypes = [];
                if (res.data!=null){
                    res.data.forEach(element => {
                        this.userTypes.push({label:element.dictLabel,value:element.dictValue})
                    })
                }
            }).catch(() => {})
    },
    //初始会员下拉框中的选项
    async getvipLevelOptions() {
           this.$http.get(`/sys/sluserviplevel/page`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.vipLevels=[];
              if (res.data!=null){
                  res.data.list.forEach(element => {
                      this.vipLevels.push({label:element.name,value:element.logo})
                  })
              }
          }).catch(() => {})
      },
      // 子级
      childHandle (row) {
        // 路由参数
        const routeParams = {
          routeName: `${this.$route.name}__${row.id}`,
        //   title: `${this.$route.meta.title} - ${row.pageName} - ${row.city}`,
          title: `经纪人信息`,
          path: 'wx/brokerChildren',
          params: {
            scopeCityId: row.id
          }
        }
        // 动态路由
        addDynamicRoute(routeParams, this.$router)
      }
    }
  }
  </script>
  <style scoped lang="scss">
  
  
  </style>
  